/* DO NOT TOUCH :) */

import React from 'react';

import pirat from '../logo/pirat.png';
import cs from '../logo/cs.png';
import inria from '../logo/inria.png';
import youtube from '../logo/yt.png'; 

import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <a href="https://www.centralesupelec.fr/" target="_blank" rel="noopener noreferrer">
          <img src={cs} alt="CS Logo" className="institution-logo" />
        </a>
        
        <div className="separator"></div> 
        
        <div className="logo-with-social">
          <a href="https://team.inria.fr/pirat/" target="_blank" rel="noopener noreferrer">
            <img src={pirat} alt="Pirat Logo" className="institution-logo" />
          </a>
          <a href="https://www.youtube.com/channel/UCfO5ej3Pyqa6DdLxFNkUyGQ" target="_blank" rel="noopener noreferrer">
            <img src={youtube} alt="YouTube Logo" className="social-logo" />
          </a>
        </div>

        <div className="separator"></div> 
        
        <a href="https://inria.fr/fr" target="_blank" rel="noopener noreferrer">
          <img src={inria} alt="Inria Logo" className="institution-logo" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;

